var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83354 15C4.79377 15 3.79659 14.6049 3.06136 13.9017C2.32613 13.1984 1.91309 12.2446 1.91309 11.25C1.91309 10.2554 2.32613 9.30161 3.06136 8.59835C3.79659 7.89509 4.79377 7.5 5.83354 7.5C6.07911 6.40598 6.79751 5.44457 7.8307 4.82726C8.34228 4.5216 8.91575 4.30962 9.51835 4.20343C10.121 4.09723 10.7409 4.0989 11.3428 4.20833C11.9447 4.31777 12.5167 4.53283 13.0263 4.84123C13.5358 5.14964 13.9729 5.54535 14.3125 6.00577C14.6521 6.4662 14.8877 6.98232 15.0057 7.52466C15.1237 8.06701 15.1218 8.62496 15.0002 9.16667H15.8335C16.6071 9.16667 17.349 9.47396 17.8959 10.0209C18.4429 10.5679 18.7502 11.3098 18.7502 12.0833C18.7502 12.8569 18.4429 13.5987 17.8959 14.1457C17.349 14.6927 16.6071 15 15.8335 15H15.0002",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 11.6667L9.16699 15H11.667L10.0003 18.3334",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIcon);
export default __webpack_public_path__ + "static/media/general-icon.df366ac8b343ccaaea576c0fa875f90d.svg";
export { ForwardRef as ReactComponent };